import React from 'react';
import PropTypes from 'prop-types';
import { Layout } from '@storable/canaveral-components';

const { Header } = Layout;
const { Panel } = Header;

const propTypes = {
  show: PropTypes.bool,
  onDismiss: PropTypes.func,
  userAuthProfile: PropTypes.object.isRequired,
  corporateUrl: PropTypes.string.isRequired,
  storEdgeUrl: PropTypes.string.isRequired,
  facilityLevelLinkText: PropTypes.string.isRequired,
};

const defaultProps = {
  show: false,
  onDismiss: undefined,
};

const AdminHeaderPanel = (
  {
    show,
    onDismiss,
    userAuthProfile,
    corporateUrl,
    storEdgeUrl,
    facilityLevelLinkText,
  },
) => (
  <Panel show={show} onDismiss={onDismiss}>
    <Panel.Item componentClass="div" active>Websites Admin</Panel.Item>
    {userAuthProfile.hasFmsAccess &&
      <Panel.Item href={storEdgeUrl}>{facilityLevelLinkText}</Panel.Item>}
    {userAuthProfile.hasCorporateAccess &&
      <Panel.Item href={`${corporateUrl}/facilities`}>Corporate Level</Panel.Item>}
  </Panel>
);

AdminHeaderPanel.propTypes = propTypes;
AdminHeaderPanel.defaultProps = defaultProps;

export default AdminHeaderPanel;
